let trigger_variant =()=>{
    let selected_var_option  = document.querySelector('.pro_variants_containor .pro_var_input_e[checked="checked"]');
    if(!selected_var_option){
        let first_var_option  = document.querySelector('.pro_variants_containor .pro_var_input_e');
        console.log("first_var_option",first_var_option);
        if(first_var_option){
             first_var_option.click();
             first_var_option.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}
trigger_variant();
document.addEventListener("DOMContentLoaded", () => {
  trigger_variant();
  function getScope(el) {
    return el.closest(".quick-add, .modal, .drawer") || document;
  }
  function getPageSelectedValue() {
    const checkedInput = document.querySelector("input.pro_var_input:checked[data-value]");
    if (checkedInput) {
      const val = checkedInput.getAttribute("data-value");
      return val;
    }
    return null;
  }

  function syncVariantState(scope = document) {
    const buttons = scope.querySelectorAll(".sg-variant-btn[data-value]");
    const rows = scope.querySelectorAll(".table-row-list[data-row-name]");

    const buttonMap = new Map();

    buttons.forEach(btn => {
      const value = btn.getAttribute("data-value");
      if (!value) return;
      buttonMap.set(value, {
        isDisabled: btn.classList.contains("disabled"),
        isSelected: btn.classList.contains("selected")
      });
    });

    rows.forEach(row => {
      const rowValue = row.getAttribute("data-row-name");
      row.classList.remove("hidden", "disabled", "selected");

      if (!buttonMap.has(rowValue)) {
        row.classList.add("hidden");
      } else {
        const data = buttonMap.get(rowValue);
        if (data.isDisabled) row.classList.add("disabled");
        if (data.isSelected) row.classList.add("selected");
      }
    });
  }

  function clearSelection(scope = document) {
    scope.querySelectorAll(".sg-variant-btn.selected, .table-row-list.selected")
      .forEach(el => el.classList.remove("selected"));
  }

  function triggerInputByValue(value, scope = document) {
    let input = document.querySelector(`input.pro_var_input[data-value="${value}"]`);

    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("input", { bubbles: true }));
    } else {
      console.warn(`[SizeChart] No input found for data-value: ${value}`);
    }
  }

  function syncSelectedVariantToPopup(popup) {
    if (!popup) return;

    const selectedValue = getPageSelectedValue();
    if (!selectedValue) {
      syncVariantState(popup);
      return;
    }

    clearSelection(popup);

    const btn = popup.querySelector(`.sg-variant-btn[data-value="${selectedValue}"]`);
    const row = popup.querySelector(`.table-row-list[data-row-name="${selectedValue}"]`);

    if (btn) btn.classList.add("selected");
    if (row) row.classList.add("selected");

    syncVariantState(popup);
  }

  function selectByValue(value, scope = document) {
    if (!value) return;

    clearSelection(scope);

    const btn = scope.querySelector(`.sg-variant-btn[data-value="${value}"]`);
    const row = scope.querySelector(`.table-row-list[data-row-name="${value}"]`);

    if (btn) btn.classList.add("selected");
    if (row) row.classList.add("selected");

    triggerInputByValue(value, scope);
    syncVariantState(scope);
  }
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;

        if (
          (node.classList?.contains("modal") || node.classList?.contains("drawer")) &&
          node.hasAttribute("open")
        ) {
          setTimeout(() => syncSelectedVariantToPopup(node), 100);
        }

        const popup = node.closest?.(".modal[open], .drawer[open]");
        if (popup) {
          setTimeout(() => syncSelectedVariantToPopup(popup), 100);
        }
      });

      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "open" &&
        mutation.target.hasAttribute("open")
      ) {
        const popup = mutation.target;
        if (
          popup.classList.contains("modal") ||
          popup.classList.contains("drawer")
        ) {
          setTimeout(() => syncSelectedVariantToPopup(popup), 100);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["open"]
  });

  document.addEventListener("click", (e) => {

    const btn = e.target.closest(".sg-variant-btn[data-value]");
    if (btn) {
      e.stopPropagation();
      if (btn.classList.contains("disabled")) return;
      selectByValue(btn.getAttribute("data-value"), getScope(btn));
      return;
    }

    const row = e.target.closest(".table-row-list[data-row-name]");
    if (row) {
      e.stopPropagation();
      if (row.classList.contains("disabled")) return;
      selectByValue(row.getAttribute("data-row-name"), getScope(row));
      return;
    }

    const submitBtn = e.target.closest(".variant-list-submit-buton");
    if (submitBtn) {
      e.stopPropagation();
      const scope = getScope(submitBtn);
      const selectedBtn = scope.querySelector(".sg-variant-btn.selected[data-value]");
      if (selectedBtn) {
        const value = selectedBtn.getAttribute("data-value");
        triggerInputByValue(value, scope);

        const modal = submitBtn.closest(".modal, .drawer");
        if (modal) {
          modal.removeAttribute("open");
          modal.dispatchEvent(new Event("close", { bubbles: true }));
        }
      }
      return;
    }

    setTimeout(() => {
      const openPopup = document.querySelector(".modal[open], .drawer[open]");
      if (openPopup) {
        syncSelectedVariantToPopup(openPopup);
      }
    }, 200);

  });
  syncVariantState();
  document.addEventListener("shopify:section:load", () => {
    syncVariantState();
  });

});


function initSgTabs(root = document) {
  const tabContainers = root.querySelectorAll('.top-barright-col');
  if (!tabContainers.length) return;

  tabContainers.forEach(container => {
    // already initialized check — double init અટકાવે
    if (container.dataset.sgTabInit) return;
    container.dataset.sgTabInit = 'true';

    const buttons = container.querySelectorAll('.sg-tab-button');
    const infos = container.querySelectorAll('.sg-tab-info');

    if (!buttons.length || !infos.length) return;

    function activateTab(tabName) {
      buttons.forEach(btn => btn.classList.remove('active'));
      infos.forEach(info => info.classList.remove('active'));

      const activeBtn = container.querySelector(`.sg-tab-button[data-tab-name="${tabName}"]`);
      const activeInfo = container.querySelector(`.sg-tab-info[data-info-name="${tabName}"]`);

      if (activeBtn) activeBtn.classList.add('active');
      if (activeInfo) activeInfo.classList.add('active');
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', function () {
        const tabName = this.getAttribute('data-tab-name');
        activateTab(tabName);
      });
    });

    const firstTab = buttons[0].getAttribute('data-tab-name');
    activateTab(firstTab);
  });
}

// Page load વખતે
document.addEventListener('DOMContentLoaded', () => initSgTabs());

// Popup reopen વખતે — નવો DOM detect કરે
const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return; // element જ જોઈએ
      // popup wrapper હોય તો અંદર tabs init કરો
      if (node.querySelector?.('.top-barright-col')) {
        initSgTabs(node);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".size-switch");
  if (!btn) return;

  const scope = btn.closest(".modal, .drawer, .quick-add") || document;

  const switches = scope.querySelectorAll(".size-switch");
  const table = scope.querySelector(".size-chart-table");
  switches.forEach(el => el.classList.remove("active"));
  btn.classList.add("active");
  if (table) {
    if (btn.classList.contains("size-switch-cm")) {
      table.classList.add("cm-size-show");
    } else {
      table.classList.remove("cm-size-show");
    }
  }
});


document.addEventListener('click', function (e) {
  const toggleBtn = e.target.closest('.mobile-show-hide-button');
  if (toggleBtn) {
    toggleBtn.classList.toggle('active');
    return;
  }
  const listBtn = e.target.closest('.mobile-list-button');
  if (listBtn) {
    const target = document.querySelector('.col.left-col');
    if (target) {
      target.classList.toggle('active');
    }
  }
});


document.addEventListener('click', function (e) {
  const button = e.target.closest('.popup-footer-button');
  if (!button) return;
  document.dispatchEvent(new KeyboardEvent('keydown', {
    key: 'Escape',
    bubbles: true
  }));

});

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.down_button_option_button').forEach((button) => {
//     button.addEventListener('click', function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//       const parentItem = this.closest('.mobile-menulist');
//       const dropdown = parentItem.querySelector('.mobile-menu-dropdown-value');
//       if (dropdown) {
//         dropdown.classList.toggle('active');
//       }
//     });
//   });
// });




(() => {
  const input = document.querySelector('.pincode_checker_input');
  const button = document.querySelector('.pincode_checker_button');
  const msg = document.querySelector('.pincode_checker_msg');
  if (!input || !button || !msg) return;

  const addBusinessDays = (date, days, excludeSaturday = false) => {
    let count = 0;
    let d = new Date(date);
    while (count < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (excludeSaturday) {
        if (day !== 0 && day !== 6) count++;
      } else {
        if (day !== 0) count++;
      }
    }
    return d;
  };

  const formatDate = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  };

  const showMsg = (text, type) => {
    msg.textContent = text;
    msg.className = `pincode_checker_msg ${type}`;
    msg.style.display = 'block';
  };

  input.addEventListener('input', () => {
    input.value = input.value.replace(/\D/g, '').slice(0, 6);
    msg.style.display = 'none';
  });
  // -d added product level metafield logic 
  /* this logic is valid when we dont have to exclude any day
  const addDays = (date, days) => {
  //   const d = new Date(date);
  //   d.setDate(d.getDate() + days);
  //   return d;
   };
   */
  const checkPin = () => {
    const value = input.value.trim();
    const today = new Date();

    if (!value) {
      return showMsg('⚠️ Please enter a pincode.', 'warning');
    }

    const isValidIndianPin = /^[1-9][0-9]{5}$/.test(value);
      // Metafields
    const wrapper = document.querySelector('.pincode_checker_msg');
    const hasMTO = wrapper.dataset.mto === 'true';
    const rtsDays = Number(wrapper.dataset.rts || 4);
    const shippingDays = Number(wrapper.dataset.shipping || 4);
    // Selected variant
    const selectedVariant = document.querySelector(
      '.pro_var_input:checked'
    );

    let variantAvailable = null;
    let variantHasMTO = null;

    if (selectedVariant) {

      // Variant availability metafield
      const variantAvailableValue =
        selectedVariant.dataset.variantAvailable;

      if (
        variantAvailableValue !== undefined &&
        variantAvailableValue !== ''
      ) {
        variantAvailable =
          variantAvailableValue === 'true';
      }

      // Variant MTO metafield
      const variantMtoValue =
        selectedVariant.dataset.variantMto;

      if (
        variantMtoValue !== undefined &&
        variantMtoValue !== ''
      ) {
        variantHasMTO =
          variantMtoValue === 'true';
      }
    }

    // Tab states
    const hasTabs = !!document.querySelector('.addon-main-tab-wrap');

    const isUnstitched = document
      .querySelector('.unstitched-tab-button')
      ?.classList.contains('active');

    // Delivery days logic
    // const baseDays = hasTabs
    //   ? (isUnstitched ? rtsDays : shippingDays)
    //   : (hasMTO ? shippingDays : rtsDays);
    // Final delivery logic

    let baseDays;
    // ----------------------------------
    // CASE 1
    // isvariantavailable EXISTS
    // ----------------------------------

    if (variantAvailable !== null) {

      // FALSE → default MTO
      if (variantAvailable === false) {

        baseDays = shippingDays;

      } else {

        // TRUE → check variant MTO

        if (variantHasMTO === true) {

          // tabs should work here

          // if (hasTabs) {

          //   baseDays = isUnstitched
          //     ? rtsDays
          //     : shippingDays;

          // } else {

          //   baseDays = shippingDays;
          // }
          baseDays = shippingDays;

        } else {

          // baseDays = rtsDays;
           if (hasTabs) {

            baseDays = isUnstitched
              ? rtsDays
              : shippingDays;

          } else {

            baseDays = rtsDays;
          }
        }
      }

    } else {

      // ----------------------------------
      // CASE 2
      // metafield NOT DEFINED
      // fallback to old product logic
      // ----------------------------------

      baseDays = hasTabs
        ? (isUnstitched ? rtsDays : shippingDays)
        : (hasMTO ? shippingDays : rtsDays);
    }

    const totalDays = isValidIndianPin
      ? baseDays
      : baseDays + 7;

    // Estimated delivery date from today
    // const deliveryDate = addDays(today, totalDays);
     const deliveryDate = addBusinessDays(today,totalDays,!isValidIndianPin);

    showMsg(
      `✓ Estimated Delivery on ${formatDate(deliveryDate)}`,
      'success'
    );

    // if (isValidIndianPin) {
    //   // India: +5 days, exclude Sunday only
    //   const deliveryDate = addBusinessDays(today, 5, false);
    //   showMsg(`✓ Estimated Delivery on ${formatDate(deliveryDate)}`, 'success');
    // } else {
    //   // Foreign: +10 days, exclude Saturday & Sunday
    //   const deliveryDate = addBusinessDays(today, 10, true);
    //   showMsg(`✓ Estimated Delivery on ${formatDate(deliveryDate)}`, 'error');
    // }
  };

  button.addEventListener('click', checkPin);

  // Recalculate automatically on variant change
  document.addEventListener('change', (e) => {

    const variantInput = e.target.closest('.pro_var_input');

    if (!variantInput) return;

    // only rerun if pincode already entered
    if (input.value.trim().length > 0) {

      checkPin();
    }
  });
  
  // Auto recalculate on stitched/unstitched switch
  document.addEventListener('click', (e) => {

    const tabBtn = e.target.closest(
      '.unstitched-tab-button, .stitched-tab-button'
    );

    if (!tabBtn) return;

    // wait for active class update
    setTimeout(() => {

      // only rerun if pincode already entered
      if (input.value.trim().length > 0) {

        checkPin();
      }

    }, 50);
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      checkPin();
    }
  });
})();

// setTimeout(()=>{
//   const switchBtns = document.querySelectorAll(".measurement-unit-switch .switch-button");
//   console.log("switchBtns",switchBtns);
// },100);

const input = document.querySelector('.pincode_checker_input');
const button = document.querySelector('.pdp-aadcart-button-wrap button');
if (input && button) {
  input.addEventListener('input', function () {
    if (this.value.trim() !== '') {
      button.removeAttribute('aria-controls');
      button.removeAttribute('aria-expanded');
    } else {
      button.setAttribute('aria-controls', 'pincode_validation');
      button.setAttribute('aria-expanded', 'false');
    }
  });
}